import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { useAuth } from 'src/libs/rainbow';
import { QueryOptions } from 'src/libs/react-query';
import { eventKeys } from './event-key';

export interface CompetitionEligibility {
  eligible: boolean;
}

export const getCompetitionEligibility = async () => {
  const { data } = await apiClient.get<CompetitionEligibility>('/v1/users/competition-eligibility');
  return data;
};

export type UseGetCompetitionEligibilityOptions<TData, TError> = QueryOptions<
  CompetitionEligibility,
  TError,
  TData,
  ReturnType<typeof eventKeys.getCompetitionEligibilityKey>
>;

export const useGetCompetitionEligibility = <TData = CompetitionEligibility, TError = Error>(
  options?: UseGetCompetitionEligibilityOptions<TData, TError>,
) => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: eventKeys.getCompetitionEligibilityKey(),
    queryFn: () => getCompetitionEligibility(),
    enabled: isAuthenticated,
    ...options,
  });
};
